import { createFileRoute } from "@tanstack/react-router"
import { MFASetupPage } from "@/pages/MFASetupPage"

export const Route = createFileRoute(
  "/_authenticated/_account/account-settings/security/mfa-setup"
)({
  component: MFASetupPage,
})
